<template>
    <div class="border"  @mouseover="mouseOver" @mouseleave="mouseLeave" :style="borderStyle">
        <div class="logo"><img :src="imgSrc"/></div>
        <div class="text">{{text}}</div>
    </div>
</template>

<script>
    export default {
        name: "card",
        data(){
            return{
                imgSrc: undefined,
                textContent: "",
                borderStyle :{},
                mouseLeaveStyle:{
                    'height': '100%',
                    'width': '100%',
                    'background': '#FFFFFF',
                    'box-shadow': '3px 1px 8px 4px rgba(205, 205, 205, 0.33)',
                    'border-radius': '21px',
                },
                mouseOverStyle:{
                    'height': '100%',
                    'width': '100%',
                    'background': '#FFFFFF',
                    'box-shadow': '3px 1px 8px 4px rgba(255, 201, 116, 0.31)',
                    'border-radius': '21px',
                },

            }
        },
        props:{
            src: String,
            text: String,
        },
        mounted() {
            this.imgSrc = require('@/'+this.src);
            this.textContent = this.text;
            this.borderStyle = this.mouseLeaveStyle;
        },
        methods:{
            mouseOver: function(){
                this.borderStyle = this.mouseOverStyle;
            },
            mouseLeave: function(){
                this.borderStyle = this.mouseLeaveStyle;
            }
        }


    }

</script>

<style lang="scss" scoped>
    .logo{
        width: 100%;
        height: 50%;
        img{
            width: 35%;
            height: 70%;
            margin-top: 15%;
        }
    }
    .text{
      width: 100%;
      height: 50%;
      font-size: 14px;
      color:#444444;
      margin-top: 15%;
      font-family: SourceHanSansCN-Medium;
    }
</style>
